import React from 'react';
import {TextInputComponent, TextInputProps} from '@gongxigames/framework/core/fragments/react';
import {CoreDI, ICurrencyFormatter, lazyInject, TextInput} from '@gongxigames/framework/core';

const TEXT_STYLE = {
    fontWeight: 'bold',
    fontFamily: 'PF DinDisplay Pro',
    fontSize: '60px',
    padding: '10px 20px',
    width: '620px',
    color: 'white'
};

const DEFAULT_BACKGROUND_COLOR = 0x555555;
const NOT_VALID_BACKGROUND_COLOR = 0xff0000;
const BOX_ROUND = 20;

type AutoplayInputProps = Omit<TextInputProps, 'textStyle' | 'boxStyle'> & {
    onChange: (value: string) => void;
    onFocus?: () => void;
    onBlur?: () => void;
    value: string;
    isNotValid?: boolean;
};

type AutoplayInputState = {
    text: string;
    formattedText: string;
    focused: boolean;
};

export class AutoplayInput extends React.Component<AutoplayInputProps, AutoplayInputState> {
    @lazyInject(CoreDI.CurrencyFormatter)
    protected readonly formatter!: ICurrencyFormatter;

    protected input = React.createRef<TextInput>();

    protected onFocus(): void {
        if (this.props.onFocus) {
            this.props.onFocus();
        }
    }

    protected onBlur(): void {
        if (this.props.onBlur) {
            this.props.onBlur();
        }
    }

    protected onInput(text: string): void {
        this.props.onChange(text);
        this.forceUpdate();
    }

    protected focus(): void {
        if (this.input) {
            this.input.current?.focus();
        }
    }

    public render(): JSX.Element {
        const {
            isNotValid,
            value,
            onBlur,
            onFocus,
            onChange,
            ...props
        } = this.props;
        const boxStyle = {fill: isNotValid ? NOT_VALID_BACKGROUND_COLOR : DEFAULT_BACKGROUND_COLOR, rounded: BOX_ROUND};

        return (
            <TextInputComponent
                {...props}
                interactive={true}
                pointertap={this.focus.bind(this)}
                textStyle={TEXT_STYLE}
                boxStyle={{default: boxStyle}}
                text={value}
                focus={this.onFocus.bind(this)}
                blur={this.onBlur.bind(this)}
                input={this.onInput.bind(this)}
                ref={this.input}
                disabledPasteFromClipboard={true}
            />
        );
    }

}
